import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToTomos = () => {
    const el = document.getElementById('tomos');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full min-h-[calc(100vh-40px)] flex flex-col items-center justify-center px-4 py-5 text-center bg-fondo-principal" data-id="element-88">
      <div className="inline-block bg-badges-dorado text-fondo-principal text-xs font-bold px-3 py-1 rounded-full mb-3" data-id="element-89">
        🎸 Método Completo · Edición 2026
      </div>

      <h1 className="sm:text-[32px] font-bold mb-3 text-[30px]" data-id="element-90">
        Tocá tu primera canción en menos de{' '}
        <span className="relative inline-block text-badges-dorado" data-id="element-91">
          30 días
          <span className="absolute left-0 -bottom-1 w-full h-[3px] bg-botones-acentos rounded-full" data-id="element-92" />
        </span>
      </h1>

      <div className="w-full max-w-[400px] sm:max-w-[460px] mx-auto mb-3 relative" data-id="element-93">
        <motion.img src="https://cdn.magicpatterns.com/uploads/gfR3StcTbfUh3G6D1KfTBs/Untitled_design_(3).png" alt="Guitarra Fácil PRO - Libro y bonos" className="w-full h-auto max-h-[52vh] object-contain mx-auto drop-shadow-2xl" animate={{
        y: [0, -12, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-94" />
      </div>

      <p className="text-sm sm:text-base text-gray-200 mb-4 max-w-md mx-auto" data-id="element-95">
        El método paso a paso para aprender guitarra desde tu casa, sin
        profesor, sin experiencia previa y sin perder meses probando solo con
        YouTube.
      </p>

      <div className="w-full flex flex-col gap-3 mb-4" data-id="element-96">
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full h-[56px] bg-botones-acentos hover:bg-orange-500 text-white font-bold rounded-xl text-lg transition-colors flex items-center justify-center gap-2" data-id="element-97">
          🎸 Quiero el Sistema Guitarra Fácil
        </button>
        <button onClick={scrollToTomos} className="w-full h-[56px] bg-transparent border-2 border-white/30 hover:border-white text-white font-semibold rounded-xl text-base transition-colors flex items-center justify-center" data-id="element-98">
          Ver qué incluye ↓
        </button>
      </div>

      <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-2 text-xs text-gray-300" data-id="element-99">
        <span className="flex items-center gap-1" data-id="element-100">⭐ 4.9/5</span>
        <span data-id="element-101">·</span>
        <span data-id="element-102">+900 personas</span>
        <span data-id="element-103">·</span>
        <span className="flex items-center gap-1" data-id="element-104">🎼 6 tomos completos</span>
        <span data-id="element-105">·</span>
        <span className="flex items-center gap-1" data-id="element-106">🔒 Garantía 7 días</span>
      </div>
    </section>;
}